import { get, post, patch, del } from "./apiClient";
import {
  CapturePayload,
  PagedResult,
  SavedItem,
  SavedItemFilter,
  GetUrlsResponse,
  GetUrlsFilter,
} from "../types";

const RESOURCE = "/urls";

const defaultPagination = {
  page: 1,
  pageSize: 20,
};

const toQueryString = (filters: SavedItemFilter = {}) => {
  const params = new URLSearchParams();
  const merged = { ...defaultPagination, ...filters };

  Object.entries(merged).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return;
    }
    params.append(key, String(value));
  });

  const query = params.toString();
  return query ? `?${query}` : "";
};

export interface SavedItemResponse extends PagedResult<SavedItem> {}

export function fetchSavedItems(filters?: SavedItemFilter) {
  return get<SavedItemResponse>(`${RESOURCE}${toQueryString(filters)}`);
}

export function fetchSavedItem(id: string) {
  return get<SavedItem>(`${RESOURCE}/${id}`);
}

export function createSavedItem(payload: CapturePayload) {
  return post<SavedItem>(RESOURCE, payload);
}

export function updateSavedItem(id: string, payload: Partial<CapturePayload>) {
  return patch<SavedItem>(`${RESOURCE}/${id}`, payload);
}

export function removeSavedItem(id: string) {
  return del<void>(`${RESOURCE}/${id}`);
}

export function triggerResummarize(id: string) {
  return post<SavedItem>(`${RESOURCE}/${id}/resummarize`);
}

// New pageable endpoint
const URLS_RESOURCE = "/urls";

const toUrlQueryString = (filters: GetUrlsFilter = {}) => {
  const params = new URLSearchParams();

  if (filters.pageSize !== undefined) {
    params.append("pageSize", String(filters.pageSize));
  }

  if (filters.continuationToken) {
    params.append("continuationToken", filters.continuationToken);
  }

  const query = params.toString();
  return query ? `?${query}` : "";
};

export function fetchUrls(filters?: GetUrlsFilter) {
  return get<GetUrlsResponse>(`${URLS_RESOURCE}${toUrlQueryString(filters)}`);
}
